import { api as generatedApi } from 'gen/rtk-openapi'
import { TAG_TYPES as COMMODITY_TAG_TYPES } from './inventory'

const TAG_TYPES = {
  regrades: 'Regrades',
  regradesMeta: 'RegradesMeta',
  inventoryCommodity: COMMODITY_TAG_TYPES.inventoryCommodity,
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.regrades, TAG_TYPES.regradesMeta, TAG_TYPES.inventoryCommodity],
  endpoints: {
    getRegrades: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(regrade => ({
                type: TAG_TYPES.regrades,
                id: regrade.id,
              })),
              { type: TAG_TYPES.regrades, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Regrades', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.regrades, id: 'LIST' }],
    },
    getRegradeById: {
      providesTags: (result, error, { regradeId }) => [{ type: TAG_TYPES.regrades, id: regradeId }],
    },
    createRegrade: {
      invalidatesTags: [
        { type: TAG_TYPES.regrades, id: 'LIST' },
        { type: TAG_TYPES.regradesMeta, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
    updateRegrade: {
      invalidatesTags: (result, error, { regradeId }) => [
        { type: TAG_TYPES.regrades, id: regradeId },
        { type: TAG_TYPES.regrades, id: 'LIST' },
        { type: TAG_TYPES.regradesMeta, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
    getInventoryRegradeMeta: {
      providesTags: () => [{ type: TAG_TYPES.regradesMeta }],
    },
    voidRegrade: {
      invalidatesTags: (result, error, { regradeId }) => [
        { type: TAG_TYPES.regrades, id: regradeId },
        { type: TAG_TYPES.regrades, id: 'LIST' },
        { type: TAG_TYPES.regradesMeta, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
  },
})

export const {
  useGetRegradesQuery,
  useGetRegradeByIdQuery,
  useCreateRegradeMutation,
  useUpdateRegradeMutation,
  useGetInventoryRegradeMetaQuery,
  useVoidRegradeMutation,
} = api
